export const useScrollTo = () => {
  const scrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return {
    scrollToAbout: () => scrollTo('aboutAnchor'),
    scrollToServices: () => scrollTo('servicesAnchor'),
    scrollToDonate: () => scrollTo('donateAnchor'),
    scrollToTestimonials: () => scrollTo('testimonialsAnchor'),
    scrollToTeam: () => scrollTo('teamAnchor'),
    scrollToContact: () => scrollTo('contactAnchor'),
    scrollToTop: () => scrollTo('header'),
  };
};
